import { Product } from '../../types';

export const series0312Products: Product[] = [
  {
    id: "bt-0312-swt031201",
    name: "0312 Series Terminal - 8.3 Female Slot (SWT031201)",
    slug: "0312-series-terminal-8-3-female-slot-swt031201",
    category: "Brass Terminal",
    subcategory: "0312 Series",
    description: "8.3mm female slot terminal for heavy-duty automotive applications. High conductivity brass construction.",
    partNumber: "SWT031201",
    featured: true,
    specifications: {
      "Tab Size Ø": "7.70 mm",
      "Cable Size SQ. MM": "3.10-4.20",
      "Description": "8.3 Female Slot",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-N/A Cut-1000",
    },
    images: ["/products/brass-terminals/0312-series/SWT031201.jpg"],
    tags: ["terminal", "0312", "brass", "female", "slot", "8.3mm"],
    applications: ["Automotive", "Heavy Duty"],
  },
  {
    id: "bt-0312-swt031202",
    name: "0312 Series Terminal - 8.3 Female Dimple (SWT031202)",
    slug: "0312-series-terminal-8-3-female-dimple-swt031202",
    category: "Brass Terminal",
    subcategory: "0312 Series",
    description: "8.3mm female dimple terminal with retention dimple. High conductivity brass construction.",
    partNumber: "SWT031202",
    specifications: {
      "Tab Size Ø": "7.70 mm",
      "Cable Size SQ. MM": "3.10-4.20",
      "Description": "8.3 Female Dimple",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-N/A Cut-1000",
    },
    images: ["/products/brass-terminals/0312-series/SWT031202.jpg"],
    tags: ["terminal", "0312", "brass", "female", "dimple", "8.3mm"],
    applications: ["Automotive", "Heavy Duty"],
  },
  {
    id: "bt-0312-swt031211",
    name: "0312 Series Terminal - 8.3 Female Lock (SWT031211)",
    slug: "0312-series-terminal-8-3-female-lock-swt031211",
    category: "Brass Terminal",
    subcategory: "0312 Series",
    description: "8.3mm female lock terminal with locking tab mechanism. Enhanced retention for secure connections.",
    partNumber: "SWT031211",
    specifications: {
      "Tab Size Ø": "7.75 mm",
      "Cable Size SQ. MM": "3.80-4.80",
      "Description": "8.3 Female Lock",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-2000 Cut-1000",
    },
    images: ["/products/brass-terminals/0312-series/SWT031211.jpg"],
    tags: ["terminal", "0312", "brass", "female", "lock", "8.3mm"],
    applications: ["Automotive", "Heavy Duty"],
  },
  {
    id: "bt-0312-swt031212",
    name: "0312 Series Terminal - 8.3 Male Lock (SWT031212)",
    slug: "0312-series-terminal-8-3-male-lock-swt031212",
    category: "Brass Terminal",
    subcategory: "0312 Series",
    description: "8.3mm male lock terminal with locking mechanism on tab. High conductivity brass construction.",
    partNumber: "SWT031212",
    specifications: {
      "Tab Size Ø": "8.85 mm",
      "Cable Size SQ. MM": "3.80-4.80",
      "Description": "8.3 Male Lock",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-2000 Cut-1000",
    },
    images: ["/products/brass-terminals/0312-series/SWT031212.jpg"],
    tags: ["terminal", "0312", "brass", "male", "lock", "8.3mm"],
    applications: ["Automotive", "Heavy Duty"],
  },
  {
    id: "bt-0312-swt031213",
    name: "0312 Series Terminal - 8.3 Female Box (SWT031213)",
    slug: "0312-series-terminal-8-3-female-box-swt031213",
    category: "Brass Terminal",
    subcategory: "0312 Series",
    description: "8.3mm female box terminal with box-like tab receiver. High conductivity brass construction.",
    partNumber: "SWT031213",
    specifications: {
      "Tab Size Ø": "7.75 mm",
      "Cable Size SQ. MM": "3.20-4.20",
      "Description": "8.3 Female Box",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-1500 Cut-1000",
    },
    images: ["/products/brass-terminals/0312-series/SWT031213.jpg"],
    tags: ["terminal", "0312", "brass", "female", "box", "8.3mm"],
    applications: ["Automotive", "Heavy Duty"],
  },
  {
    id: "bt-0312-swt031214",
    name: "0312 Series Terminal - 8.3 Male Window (SWT031214)",
    slug: "0312-series-terminal-8-3-male-window-swt031214",
    category: "Brass Terminal",
    subcategory: "0312 Series",
    description: "8.3mm male window terminal with window opening on tab. High conductivity brass construction.",
    partNumber: "SWT031214",
    specifications: {
      "Tab Size Ø": "8.95 mm",
      "Cable Size SQ. MM": "3.20-4.20",
      "Description": "8.3 Male Window",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-1500 Cut-1000",
    },
    images: ["/products/brass-terminals/0312-series/SWT031214.jpg"],
    tags: ["terminal", "0312", "brass", "male", "window", "8.3mm"],
    applications: ["Automotive", "Heavy Duty"],
  },
  {
    id: "bt-0312-swt031215",
    name: "0312 Series Terminal - 8.3 Male Window (SWT031215)",
    slug: "0312-series-terminal-8-3-male-window-swt031215",
    category: "Brass Terminal",
    subcategory: "0312 Series",
    description: "8.3mm male window terminal with window opening on tab. Alternative variant for heavy-duty applications.",
    partNumber: "SWT031215",
    specifications: {
      "Tab Size Ø": "8.95 mm",
      "Cable Size SQ. MM": "3.80-4.80",
      "Description": "8.3 Male Window",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-2000 Cut-1000",
    },
    images: ["/products/brass-terminals/0312-series/SWT031215.jpg"],
    tags: ["terminal", "0312", "brass", "male", "window", "8.3mm"],
    applications: ["Automotive", "Heavy Duty"],
  }
];
